export const handleStripePriceId = ({ tier = '0', isAnnual = false }) => {
    let tierId;
    switch (tier) {
        case 'GU0':
            if (isAnnual) {
                tierId = process.env.REACT_APP_STRIPE_BASIC_YEARLY;
                break;
            };
            tierId = process.env.REACT_APP_STRIPE_BASIC_MONTHLY;
            break;
        case 'iUZ':
            if (isAnnual) {
                tierId = process.env.REACT_APP_STRIPE_PRO_YEARLY
                break;
            };
            tierId = process.env.REACT_APP_STRIPE_PRO_MONTHLY;
            break;
        case 's6W':
            if (isAnnual) {
                tierId = process.env.REACT_APP_STRIPE_SCALE_YEARLY;
                break;
            };
            tierId = process.env.REACT_APP_STRIPE_SCALE_MONTHLY;
            break;
        case 'Do4':
            if (isAnnual) {
                tierId = process.env.REACT_APP_STRIPE_QR_EVERYTHING_YEARLY;
                break;
            };
            tierId = process.env.REACT_APP_STRIPE_QR_EVERYTHING_MONTHLY;
            break;
        default:
            if (tier === 'free' || tier === '0' || tier === 0) {
                tierId = 'free';
                break;
            };

            if (!tier) {
                tierId = undefined;
                break;
            };

            tierId = 'unknown';
            break;
    };

    return tierId;
};